import { useState } from "react";


const LocationTutorial = () => {
    const [run, setRun] = useState(false);



    return (
        <div className="p-5">
            {/* Banner de aviso */}
            <div className="location-banner bg-[#f2d0a9] text-black p-3 rounded-md text-center">
                📍 Por favor, activa la ubicación en tu dispositivo para disfrutar de todos los servicios. ¡Es necesario para que todo funcione correctamente! Si ya la activaste, refresca la página para continuar.
            </div>


        </div>
    );
};

export default LocationTutorial;
